
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pos-hardware-partners/sunmi",
      function () {
        return require("private-next-pages/pos-hardware-partners/sunmi.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pos-hardware-partners/sunmi"])
      });
    }
  